import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {formatDateString, formatDateToAmericanFormat, parseLocalDate} from "../../utils/utils";
import Config from "../../core/config";
import DatePicker from "react-datepicker";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import WhatsAppButton from "../../core/WhatsAppButton";
import SearchButton from '../common/SearchButton';
import {useReactToPrint} from "react-to-print";

const apiUrl = Config.apiUrl;
const KidsBirthday = () => {
    let [customerKidBirthday, setCustomerKidBirthday] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [, setLoading] = useRecoilState(loadingAtom);
    const componentRef = useRef();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const newStartDate = startDate ? startDate : new Date(1900, 0, 1);
            const newEndDate = endDate ? endDate : new Date(2100, 0, 1);
            const url = `${apiUrl}/api/customers/customer-kid-details?startDate=${formatDateToAmericanFormat(newStartDate)}&endDate=${formatDateToAmericanFormat(newEndDate)}`;
            const response = await makeRequest(url, 'GET');
            setCustomerKidBirthday(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        makeQuery('');
    }, []);

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };

    const handleQuery = async () => {
        await makeQuery();
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Aniversariantes',
        pageStyle: `
      @page {
        size: A4 portrait;
        margin: 12mm;
      }
      @media print {
        html, body {
          width: 100%;
          height: auto;
          overflow: visible !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .birthday-print-wrapper * {
          overflow: visible !important;
        }
        .birthday-print-wrapper .birthday-filters-section,
        .birthday-print-wrapper button {
          display: none !important;
        }
        .birthday-print-wrapper .birthday-col--whatsapp {
          display: none !important;
        }
        .birthday-print-wrapper table.birthday-table {
          display: table !important;
          width: 100% !important;
          max-width: 100% !important;
          table-layout: fixed !important;
          border-collapse: collapse !important;
        }
        .birthday-print-wrapper colgroup col.birthday-col--whatsapp {
          display: none !important;
          width: 0 !important;
        }
        .birthday-print-wrapper thead {
          display: table-header-group !important;
        }
        .birthday-print-wrapper tbody {
          display: table-row-group !important;
        }
        .birthday-print-wrapper tr {
          display: table-row !important;
          page-break-inside: avoid;
        }
        .birthday-print-wrapper th,
        .birthday-print-wrapper td {
          display: table-cell !important;
          white-space: normal !important;
          word-break: break-word !important;
          border: 1px solid #595555 !important;
          padding: 4px 6px !important;
          font-size: 11px !important;
        }
      }
    `,
    });

    return (
        <>
            <div ref={componentRef} className="birthday-print-wrapper">
                <div className="header-label">Consulta de Aniversariantes</div>
                <div className="birthday-filters-section"
                    style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', width: '100%'}}>
                    <div style={{marginTop: '5px', alignItems: 'center'}}>
                        <div style={{marginTop: '5px', alignItems: 'center'}}>
                            Período:
                            <div style={{marginTop: '5px', display: 'flex', alignItems: 'center'}}>
                                <DatePicker
                                    className="datepicker"
                                    selected={startDate}
                                    onChange={handleStartDateChange}
                                    dateFormat="dd/MM/yyyy"
                                    isClearable
                                    autoComplete="off"
                                />
                                até
                                <DatePicker
                                    className="datepicker"
                                    selected={endDate}
                                    onChange={handleEndDateChange}
                                    dateFormat="dd/MM/yyyy"
                                    isClearable
                                    autoComplete="off"
                                />
                                <SearchButton title="Consultar" onClick={handleQuery}/>
                            </div>
                        </div>
                    </div>
                </div>
                <table className="birthday-table" style={{width: '800px'}}>
                    <colgroup>
                        <col style={{width: '50px'}}/>
                        <col style={{width: '220px'}}/>
                        <col style={{width: '120px'}}/>
                        <col className="birthday-col--whatsapp" style={{width: '40px'}}/>
                        <col style={{width: '220px'}}/>
                        <col style={{width: '100px'}}/>
                        <col style={{width: '50px'}}/>
                    </colgroup>
                    <thead>
                        <tr>
                            <th><div style={{textAlign: 'center'}}>Código</div></th>
                            <th>Nome do Cliente</th>
                            <th>Telefone</th>
                            <th className="birthday-col--whatsapp"/>
                            <th>Nome da Criança</th>
                            <th><div style={{textAlign: 'center'}}>Nascimento</div></th>
                            <th><div style={{textAlign: 'center'}}>Idade</div></th>
                        </tr>
                    </thead>
                    <tbody style={{overflowY: 'auto'}}>
                    {customerKidBirthday.map((item, index) => (
                        <tr key={index}>
                            <td><div style={{textAlign: 'center'}}>{item.customerCode}</div></td>
                            <td><div>{item.customerName}</div></td>
                            <td><div>{item.customerPhoneNumber}</div></td>
                            <td className="birthday-col--whatsapp">
                                {item.customerPhoneNumber &&
                                    <WhatsAppButton
                                        phoneNumber={item.customerPhoneNumber}
                                        personName={item.customerName}
                                    />
                                }
                            </td>
                            <td><div>{item.kidName}</div></td>
                            <td><div style={{textAlign: 'center'}}>{formatDateString(parseLocalDate(item.kidBirthDate))}</div></td>
                            <td><div style={{textAlign: 'center'}}>{item.age}</div></td>
                        </tr>
                    ))}
                    </tbody>
                    {customerKidBirthday.length === 0 && (
                        <tfoot><tr><td colSpan={7}>Nenhum item encontrado.</td></tr></tfoot>
                    )}
                </table>
            </div>
            <div style={{marginTop: '10px'}}>
                <button className="print-button" onClick={handlePrint}>Imprimir</button>
            </div>
        </>
    );
};

export default KidsBirthday;
